import React, { useState, useEffect } from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types'
import axios from 'axios'
import { useHistory } from 'react-router-dom';
import './theme.scss'

const theme = {
    container: 'container',
    containerOpen: 'container--open',
    input: 'input',
    inputOpen: 'input--open',
    inputFocused: 'input--focused',
    suggestionsContainer: 'suggestions-container',
    suggestionsContainerOpen: 'suggestions-container--open',
    suggestionsList: 'suggestions-list',
    suggestion: 'suggestion',
    suggestionFirst: 'suggestion--first',
    suggestionHighlighted: 'suggestion--highlighted'
}

export default function SearchBar({ searchType, placeholder }) {

    const [value, setValue] = useState('')
    const [suggestions, setSuggestions] = useState([])
    const [commodities, setCommodities] = useState([{ name: '', urlKey: '' }])
    const [counties, setCounties] = useState([{ name: '', urlKey: '' }])
    const history = useHistory()

    useEffect(() => {
        let list = []
        if (searchType === 'commodity') {
            const fetchData = async () => {
                const result = await axios('/wp-json/commodities/v1/all')
                for (const key in result.data) {
                    list.push({ name: result.data[key].CommodityName, urlKey: result.data[key].UrlKey })
                }
                setCommodities(list)
            }
            fetchData()
        } else {
            const fetchData = async () => {
                const result = await axios('/wp-json/counties/v1/all')

                for (const key in result.data) {
                    list.push({ name: result.data[key].CountyName, urlKey: result.data[key].UrlKey })
                }
                const filtered = list.filter(el => el.name !== undefined)
                setCounties(filtered)
            }
            fetchData()
        }
    }, [searchType])

    const getSuggestionValue = suggestion => suggestion.name;

    const escapeRegexCharacters = str => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    const getSuggestions = value => {
        const escapedValue = escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }
        
        const regex = new RegExp('\\b' + escapedValue, 'i');

        if (searchType === 'commodity') {
            commodities.sort((a,b) => (a.name > b.name) ? 1 : -1)
            return commodities.filter(commodity => regex.test(getSuggestionValue(commodity)));
        } else {
            counties.sort((a,b) => (a.name > b.name) ? 1 : -1)
            return counties.filter(county => regex.test(getSuggestionValue(county)));
        }
    };

    const renderSuggestion = suggestion => (
        <div>
            {suggestion.name}
        </div>
    );

    const onChange = (event, { newValue }) => {
        setValue(newValue)
    };

    const onSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(value))
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([])
    };

    const onSuggestionSelected = (event, { suggestion, suggestionValue, index, method }) => {
        event.preventDefault();
        if (searchType === 'commodity') {
            axios.get(`/wp-json/getcommodity/v1?url_key=${suggestion.urlKey}`)
                .then(res => res.data[0])
                .then(data => {
                    history.push({
                        pathname: '/overview/commodity',
                        state: { 
                            commodityName: data.CommodityName, 
                            urlKey: data.UrlKey 
                        }
                    })
                })
                .catch(e => e)
        } else {
            axios.get(`/wp-json/county/v1?url_key=${suggestion.urlKey}`)
                .then(res => res.data[0])
                .then(data => {
                    history.push({
                        pathname: '/overview/county',
                        state: { 
                            countyName: data.CountyName, 
                            urlKey: data.UrlKey 
                        }
                    })
                })
                .catch(e => e)
        }
    }

    let inputProps = {}

    if (searchType === 'commodity') {
         inputProps = {
            placeholder: 'Search By Commodity',
            value,
            onChange
        };
    } else {
         inputProps = {
            placeholder: 'Search By County',
            value,
            onChange
        };
    }

    if (placeholder) {
        inputProps.placeholder = placeholder;
    }

    return (
        <Autosuggest
            theme={theme}
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            onSuggestionSelected={onSuggestionSelected}
            inputProps={inputProps}
        />
    );
}

SearchBar.propTypes = {
  value: PropTypes.string,
  suggestions: PropTypes.array,
  commodities: PropTypes.array,
  counties: PropTypes.array
}